/** @format */

import { Menu, Popup } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducer/store";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { ui } from "services";
import { useState } from "react";
import { clearUserInfo } from "reducer/user.slice";
import { clearAuthInfos } from "reducer/wallet.slice";
import { SSO_META } from "config";
import { PageComponent } from "components/page-component/page-component";
import { SingleSignon } from "components/singlesignon/singlesignon";
import { Link } from "react-router-dom";
export default function Header() {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const nav = useNavigate();
  const [clickedLogout, setClickedLogout] = useState(false);

  async function onLogoutClick() {
    setClickedLogout(true);
    await ui.confirm(t("Are you sure want to logout?"), () =>
      setClickedLogout(false)
    );
    dispatch(clearUserInfo());
    dispatch(clearAuthInfos());
    sessionStorage.clear();
    localStorage.clear();
    nav("/");
  }

  return (
    <div className="main-header bg-black-primary fixed top-0 left-0 w-full">
      <div
        className="flex items-center justify-between px-6"
        style={{ height: 80 }}
      >
        <Link to="/">
          <img src="/assets/images/logo.png" alt="logo" className="h-8" />
        </Link>
        <div>
          {user?.id && (
            <Menu.Item className="hoverless">
              <span
                className="flex bg-black-linear-3 py-4 px-10 text-white-light cursor-pointer hover-orange items-center"
                onClick={onLogoutClick}
              >
                <img
                  src="/assets/images/icons/logout-icon.svg"
                  alt="logout"
                  className="h-6 w-6 mr-2"
                />{" "}
                Logout
              </span>
            </Menu.Item>
          )}
          {!user?.id && (
            <Menu.Item>
              <span className="xl:hidden block">
                <SingleSignon
                  SSO_META={SSO_META()}
                  type="signin"
                  device="mobile"
                />
              </span>
              <span className="xl:block hidden">
                <SingleSignon
                  SSO_META={SSO_META()}
                  type="signin"
                  device="laptop"
                />
              </span>
            </Menu.Item>
          )}
        </div>
      </div>
    </div>
  );
}
